module.exports = __webpack_public_path__ + "portal-static/img/defaultImage.1b352ec4.png";